<template>
    <div>
        <div class="tile is-ancestor">
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <h4 class="title is-4">
                        内拉新书库白名单
                        <a href="/audit/user-article-review" style="float: right;"
                            ><el-button type="primary">返回审核列表</el-button></a
                        >
                    </h4>
                    <div class="control">
                        <div class="filter-item">
                            <el-input placeholder="书籍ID" @keyup.enter.native="search" v-model.trim="filter.book_id">
                            </el-input>
                        </div>
                        <div class="filter-item">
                            <el-date-picker
                                v-model="auditDateRange"
                                type="daterange"
                                @change="search"
                                placeholder="加入时间"
                            >
                            </el-date-picker>
                        </div>
                        <div class="filter-item">
                            <el-button type="primary" @click="search">搜索</el-button>
                        </div>
                        <div class="filter-item">
                            <el-button type="primary" @click="dialog()">加入白名单</el-button>
                        </div>
                    </div>

                    <div class="control">
                        <el-table v-loading="loading" element-loading-text="拼命加载中" :data="list">
                            <el-table-column prop="book_id" label="书籍ID"> </el-table-column>
                            <el-table-column prop="create_time" label="添加时间"> </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button
                                        @click.native.prevent="handleRemove(scope.row.book_id)"
                                        type="primary"
                                        size="small"
                                    >
                                        移除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="control">
                        <el-pagination
                            @current-change="handleCurrentChange"
                            :current-page="filter.page"
                            :page-size="filter.page_size"
                            layout="total, prev, pager, next, jumper"
                            :total="totalPageSize"
                        >
                        </el-pagination>
                    </div>
                </article>
            </div>
        </div>
        <black-white-dialog :set-api="setBlackWhiteApi" ref="blackWhiteDialog" @close="getList"> </black-white-dialog>
    </div>
</template>

<style scrop>
.filter-item {
    display: inline-block;
    margin-right: 20px;
}

.number {
    border-radius: 0;
}

.view-rest {
    margin-bottom: 10px;
}
</style>

<script>
import dateFormat from '@/common/js/DateFormat';
import QuRequest from '@/core/QuRequest';
import blackWhiteDialog from '@/common/widget/BlackWhiteDialog';

const quRequest = new QuRequest();

export default {
    components: {
        blackWhiteDialog
    },
    data () {
        return {
            list: [],
            groupList: [],
            sourceList: [],
            categoryList: [],
            filter: {
                page: 1,
                page_size: 30,
                product_key: 'midu',
                app_key: 'story',
                book_id: '',
                create_time_start: dateFormat(-7),
                create_time_end: dateFormat()
            },
            setBlackWhiteApi: quRequest.Apis.audit.contentauditwhite.add,
            totalPageSize: 0,
            loading: false
        };
    },
    computed: {
        auditDateRange: {
            set (newValue) {
                if (newValue) {
                    this.filter.create_time_start = this.formatDate(newValue[0]);
                    this.filter.create_time_end = this.formatDate(newValue[1]);
                } else {
                    this.filter.create_time_start = '';
                    this.filter.create_time_end = '';
                }
            },
            get () {
                return [this.filter.create_time_start, this.filter.create_time_end];
            }
        }
    },
    methods: {
        formatDate (dateStr) {
            // 格式化日期
            if (dateStr) {
                let date = new Date(dateStr);
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                let d = date.getDate();
                return [y, this.addZero(m), this.addZero(d)].join('/');
            } else {
                return '';
            }
        },
        addZero: function (num) {
            return (num > 9 ? '' : '0') + num;
        },
        handleCurrentChange (page) {
            // 点击分页时获取新数据
            this.filter.page = page;
            this.getList();
        },
        search () {
            // 响应搜索事件
            this.filter.page = 1;
            this.getList();
        },
        getList () {
            // 更新列表数据
            let filter = this.filter;
            this.$updateRouter(filter);

            this.loading = true;

            quRequest
                .send(quRequest.Apis.audit.contentauditwhite.list, this.filter)
                .then(({ data }) => {
                    this.list = data.list || [];
                    this.totalPageSize = data.total || 0;
                })
                .catch(res => {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                })
                .fin(() => {
                    this.loading = false;
                });
        },
        dialog () {
            let type = this.filter.type;
            this.$refs.blackWhiteDialog.showDialog(type, '加入白名单');
        },
        // 移除
        handleRemove (id) {
            this.loading = true;
            quRequest
                .send(quRequest.Apis.audit.contentauditwhite.delete, {
                    book_ids: id,
                    product_key: 'midu',
                    app_key: 'story'
                })
                .then(res => {
                    this.$message.warning(res.message);
                })
                .catch(err => {
                    this.$message.error(err.message);
                })
                .fin(() => {
                    this.getList();
                    this.loading = false;
                });
        }
    },
    mounted () {
        this.search();
    }
};
</script>
